import React, { useState, useContext } from 'react';
import MyUserContext from './../myUserContext.js';
import {localizeKey} from './../localize.js';
import { UnstyledButton, Text, Collapse } from "@mantine/core";

function Collapsible({ children, buttonText, collapsed, doOverrideNativeText, beforeTextImgUrl }) {
  const myUser = useContext(MyUserContext);

  const [isVisible, setIsVisible] = useState(collapsed === false ? true : false);

  const toggleVisibility = () => {
    setIsVisible(prev => !prev);
  };

  const language = myUser ? myUser.myUserSettings.lang : 'ru';

  return (
    <>
      <UnstyledButton
        className="flex items-center justify-center h-10 leading-none w-full"
        onClick={toggleVisibility}
      >
        {beforeTextImgUrl && (
          <img className="w-7 h-7 rounded-full mr-1" src={beforeTextImgUrl} />
        )}
        <Text size="sm" c="blue" td="hover:underline">
          {isVisible ? ( doOverrideNativeText ? "" : localizeKey('collapsibleHideCap', language) ) + " " + buttonText : ( doOverrideNativeText ? "" : localizeKey('collapsibleShowCap', language) ) + " " + buttonText}
        </Text>
      </UnstyledButton>
      <Collapse in={isVisible}>
        <div>
          {children}
        </div>
      </Collapse>
    </>
  );
}

export default Collapsible;
